import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from '@app/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private api: ApiService) {
  }

  getOptions(): Observable<any> {
    return this.api.post('UserManagement/options')
  }

  getUserList(): Observable<any> {
    return this.api.post('UserManagement/getUserList')
  }

  addNewUser(sendData: any): Observable<any> {
    return this.api.post('UserManagement/createNewUser', sendData)
  }

  saveInstitution(sendData: any): Observable<any> {
    return this.api.post('InstitutionManagement/saveInstitution', sendData);
  }

  listInstitution(): Observable<any> {
    return this.api.post('InstitutionManagement/listInstitution')
  }

  getinstitutionOptions(): Observable<any> {
    return this.api.post('InstitutionManagement/Options')
  }

}
